var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTaxesStroke(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.33313,
    width: 26.6667,
    height: 26.6667,
    fill: "url(#pattern0_72_228)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_72_228",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_72_228",
    transform: "scale(0.0263158)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_72_228",
    width: 38,
    height: 38,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAmCAYAAACoPemuAAADt0lEQVRYhe2YXahVRRTHf/dyjLxKmV0tud2oaBShSUFB8KVIiB4UpaCHPoy0xgxSbmqKgmJRVzMNy48cIsL0xYeieouQfBF8CJN5iJwkuCZ+JKKBKWYpS9a+Tsd9rvvse/ath/5wOGevmTPz22s+1pppYxDyxo4FngYeA+7Xln4B9gJ7XAynyrZeCswbey+wEpgHDGtQ7U/gE+AdF0NfpWDe2E5gNfBKDtBv+j0mB/Aj4E0Xw+mWgnljhwOLgRXA7UnRCeADYJeL4ajW7QaeAxYBdyd1zwHrgM0uhguDAvPGSvmzwNuADF+m02rb0agTfZkFwCqgMynqU9tuF8OVpsG8sY8AG4EpifkisAlY72L4faCXStq5DVgOvA7cmhR9DyxxMewrBOaNHQ+8C8xOzPJmn8mbuhh+LQKU0+496uXn6/r9EnjDxXA4F8wbO0omKLAQqCV1vgOWuhjkDQctb6yMwHvAo0lbl4HtsrBcDGf7wbyxDwLfJHuR6CdgmYvh6xbw3CBv7CxgAzAhKZM98HEXw89t3thbgB+AiVooE3uN/NfFcLkKqEzeWBkZB6xNFsiPwGQBmw98rMb9wJMuhpNVAuUA3gV8DkxX00vtwJykztyhhhJpn3MT0xwB69aHky6GI0MNlUn7zpzS3Z6UVTqfCqqfoaY78SSgyxsr8e448PcQA4mDxiULoK+m8esJDcqddeHj35AE/XXZPiab3muAhKH7FEaC8pkETIJ3o7JWSbatD2Uz/0dI8sbKCv1CH190MXxapKwKtVfZ+GD0P1iz+s+C1QrUKSVv7J2S4eoJ6hjQ42L4tlFb3lgJ5r3AThdDT5UeE6ingDuAhyQh1GCdB7VQ64/W80KlQzmj7rkDmNYAaltiWlU1WF4KfuwmUK+6GHzVYD3AHylHmp43gNqePVQGphP9AT3UTHUxLCgKRZWrkusJ4FeprQgU9cc3b+zL8qWP5+tyNMk+OvS3HHIvJWVS95lGZ8RmoUg9plBbkrIRA/QxXD+ZJPOYCTQEawaqH8wb+0LiKdFZTUHODQCXSjy4tSyUpl1dwIHszNGmd1ySb4/Ueqv1CuDSDT2UUAGoHXqEQ1fxbFk44rH5CVSvi+GtVgA14SmXlMscfh+w7Zq1iv4ST7UQyhWYU105f71mq+khAL042eeNLcNxXjs+lNh6bwIlOqDD15HY9mZgB4GH9fekMlQquUdLwXZqQJYbonRh9UsmujdWNmAZPvGUQF3biGXyy9WkXG4IVNnL4jyPlRdwFQ3rRormfki/AAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaxesStroke);
export default __webpack_public_path__ + "static/media/taxes-stroke.7f74e88fb3305aad197fa76f43eacd48.svg";
export { ForwardRef as ReactComponent };